export default __webpack_public_path__ + "static/media/HeaderImage.d19f4377.jpg";